import { render, staticRenderFns } from "./AssetsLoad.vue?vue&type=template&id=193bc66c&scoped=true&"
import script from "./AssetsLoad.vue?vue&type=script&lang=js&"
export * from "./AssetsLoad.vue?vue&type=script&lang=js&"
import style0 from "./AssetsLoad.vue?vue&type=style&index=0&id=193bc66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bc66c",
  null
  
)

export default component.exports